export const isDown = (change = ''): boolean => {
    return change.includes('-');
};
